<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8 header_gradiant"
    >
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <stats-card>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item router_header">
                  <router-link to="/admin/pacientes">Pacientes</router-link>
                </li>
                <li class="breadcrumb-item router_header">Dispensa de Óleos</li>
              </ol>
            </nav>
            <div class="card">
              <div class="card-header">
                <div>
                  <button
                    @click="abrirDis"
                    type="button"
                    class="btn_salvar_oleo"
                    title="Nova Dispensa"
                  >
                    Nova Dispensa
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="row mt-4 mb-4" v-if="state.div_nova_dispensa">
                  <div class="col-md-3">
                    <label>Óleo</label>
                    <select v-model="state.oleo_id" :disabled="state.is_saving">
                      <option disabled value="">Selecione um óleo</option>
                      <option
                        v-for="oleo in state.tipos_oleos"
                        :key="oleo.id"
                        :value="oleo.id"
                        :disabled="Number(oleo.estoque) <= 0"
                      >
                        {{ oleo.nome }} — {{ Number(oleo.estoque) || 0 }} em estoque
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label>Lote</label>
                    <select
                      v-model="state.lote_id"
                      :disabled="state.is_saving || !state.oleo_id"
                    >
                      <option disabled value="">
                        {{
                          state.oleo_id
                            ? "Selecione um lote"
                            : "Escolha o óleo primeiro"
                        }}
                      </option>
                      <option
                        v-for="lote in state.lotes"
                        :key="lote.id"
                        :value="lote.id"
                      >
                        {{ rotuloLote(lote) }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label>Quantidade</label>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      v-model.number="state.quantidade"
                      :disabled="state.is_saving"
                    />
                  </div>
                  <div class="col-md-2">
                    <label>Data</label>
                    <input
                      v-mask="'##/##/####'"
                      maxlength="10"
                      placeholder="Insira uma DATA:"
                      v-model="state.data_hora_dispensa"
                      inputmode="numeric"
                      :disabled="state.is_saving"
                    />
                  </div>
                  <div class="col-md-2 div_btn_s_label">
                    <button
                      class="btn btn_salvar btn_sem_label"
                      id="submit-button"
                      type="button"
                      @click="saveDispensa"
                      :disabled="state.is_saving"
                    >
                      {{ state.is_saving ? "Salvando..." : "Salvar" }}
                    </button>
                  </div>
                </div>

                <p v-if="state.paciente_nome" class="paciente-identificacao">
                  Paciente: {{ state.paciente_nome }}
                </p>

                <div class="row table-responsive">
                  <table class="table mt-4 mb-4">
                    <thead class="">
                      <tr>
                        <th class="text-light font-weight-bold" scope="col">
                          Óleo Id
                        </th>
                        <th class="text-light font-weight-bold" scope="col">
                          Óleo
                        </th>
                        <th class="text-light font-weight-bold" scope="col">
                          Quantidade
                        </th>
                        <th class="text-light font-weight-bold" scope="col">
                          Lote
                        </th>
                        <th class="text-light font-weight-bold" scope="col">
                          Data e Hora
                        </th>
                        <th class="text-light font-weight-bold" scope="col">
                          Ação
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="oleo in state.oleos" :key="oleo.id">
                        <th scope="row">{{ obterOleoId(oleo) }}</th>
                        <td>{{ obterOleoNome(oleo) }}</td>
                        <td>{{ oleo.quantidade }}</td>
                        <td>{{ formatarLotes(oleo) }}</td>
                        <td>{{ oleo.data_hora_dispensa }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-danger"
                            @click="deleteDispensa(oleo.id)"
                            :disabled="state.deleting_id === oleo.id"
                          >
                            <i class="bi bi-trash-fill"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!state.is_loading && state.oleos.length === 0">
                        <td colspan="6" class="text-center">
                          Nenhuma dispensa registrada para este paciente.
                        </td>
                      </tr>
                      <tr v-if="state.is_loading">
                        <td colspan="6" class="text-center">Carregando...</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="div_btns">
                  <router-link to="/admin/pacientes">
                    <button
                      class="btn btn_cancelar"
                      id="submit-button"
                      type="button"
                    >
                      Voltar
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </stats-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  setup() {
    const storage = useStorage();
    const router = useRouter();
    const route = useRoute();
    const token = storage.getStorageSync("token");
    const pacienteId = Number(route.params.id);

    const state = reactive({
      oleos: [],
      tipos_oleos: [],
      div_nova_dispensa: false,
      oleo_id: "",
      lote_id: "",
      lotes: [],
      quantidade: 1,
      data_hora_dispensa: "",
      paciente_nome: "",
      is_loading: false,
      is_saving: false,
      deleting_id: null,
    });

    onMounted(async () => {
      if (!Number.isInteger(pacienteId) || pacienteId <= 0) {
        toast.error("Paciente inválido.");
        await router.replace("/admin/pacientes");
        return;
      }

      await Promise.all([fetchTiposOleo(), fetchTipoOleo(), fetchPaciente()]);
    });

    // Trocar de oleo rapido dispara varias buscas; so a ultima pode escrever
    // no state, senao uma resposta atrasada sobrescreve a lista correta.
    let buscaLotes = 0;

    watch(
      () => state.oleo_id,
      async (oleoId) => {
        const requisicao = ++buscaLotes;
        Object.assign(state, { lotes: [], lote_id: "" });

        if (!oleoId) return;

        try {
          const { data } = await services.tipos_oleo.lotesEstoque({
            id: oleoId,
            token,
          });

          if (requisicao !== buscaLotes) return;

          // O backend devolve em ordem FEFO; o primeiro com saldo vira a
          // sugestao, mas o operador pode trocar.
          const disponiveis = Array.isArray(data)
            ? data.filter((lote) => Number(lote.saldo) > 0)
            : [];

          Object.assign(state, {
            lotes: disponiveis,
            lote_id: disponiveis.length ? disponiveis[0].id : "",
          });
        } catch (error) {
          if (requisicao !== buscaLotes) return;

          Object.assign(state, { lotes: [] });
          toast.error(obterMensagemErro(error, "Não foi possível carregar os lotes."));
        }
      }
    );

    function rotuloLote(lote) {
      const manipulacao = lote.data_manipulacao
        ? " — manipulado em " + formatarDataSimples(lote.data_manipulacao)
        : "";
      return lote.lote + " — " + lote.saldo + " em estoque" + manipulacao;
    }

    // data_manipulacao vem como "AAAA-MM-DD"; converter com Date() deslocaria
    // o dia por causa do fuso.
    function formatarDataSimples(data) {
      if (!data) return "";
      const partes = String(data).slice(0, 10).split("-");
      return partes.length === 3
        ? partes[2] + "/" + partes[1] + "/" + partes[0]
        : data;
    }

    function formatarLotes(dispensa) {
      if (!Array.isArray(dispensa.lotes) || dispensa.lotes.length === 0) {
        return "—";
      }
      return dispensa.lotes
        .map((item) => item.lote + " (" + item.quantidade + ")")
        .join(", ");
    }

    function abrirDis() {
      if (state.div_nova_dispensa === false) {
        state.div_nova_dispensa = true;
      } else {
        state.div_nova_dispensa = false;
      }
    }

    async function fetchTipoOleo() {
      state.is_loading = true;
      try {
        const { data } = await services.tipos_oleo.dispensaOleoCliente({
          id: pacienteId,
          token,
        });
        state.oleos = Array.isArray(data) ? data : [];
      } catch (error) {
        state.oleos = [];
        toast.error(obterMensagemErro(error, "Não foi possível carregar as dispensas."));
      } finally {
        state.is_loading = false;
      }
    }

    async function fetchTiposOleo() {
      try {
        const { data } = await services.tipos_oleo.getAll({ token });
        state.tipos_oleos = Array.isArray(data)
          ? data.filter((oleo) => oleo.status === "ATIVO")
          : [];
      } catch (error) {
        state.tipos_oleos = [];
        toast.error(obterMensagemErro(error, "Não foi possível carregar os tipos de óleo."));
      }
    }

    async function fetchPaciente() {
      try {
        const { data } = await services.paciente.obterPorId({ id: pacienteId, token });
        state.paciente_nome = data && data.pessoa ? data.pessoa.nome : "";
      } catch (error) {
        toast.error(obterMensagemErro(error, "Não foi possível identificar o paciente."));
      }
    }

    async function saveDispensa() {
      if (!state.oleo_id) {
        toast.error("Selecione o óleo dispensado.");
        return;
      }

      if (!dataBrasileiraValida(state.data_hora_dispensa)) {
        toast.error("Informe uma data válida no formato DD/MM/AAAA.");
        return;
      }

      if (!Number.isInteger(state.quantidade) || state.quantidade <= 0) {
        toast.error("Informe uma quantidade inteira maior que zero.");
        return;
      }

      const oleoSelecionado = state.tipos_oleos.find(
        (oleo) => Number(oleo.id) === Number(state.oleo_id)
      );
      if (!state.lote_id) {
        toast.error("Selecione o lote de onde sairá a dispensa.");
        return;
      }

      if (!oleoSelecionado || Number(oleoSelecionado.estoque) < state.quantidade) {
        toast.error(
          `Estoque insuficiente. Saldo disponível: ${
            oleoSelecionado ? Number(oleoSelecionado.estoque) : 0
          } unidade(s).`
        );
        return;
      }

      state.is_saving = true;
      try {
        await services.tipos_oleo.saveDispensa(
          {
            pet_paciente_id: pacienteId,
            oleo_id: state.oleo_id,
            lote_id: state.lote_id,
            quantidade: state.quantidade,
            data_hora_dispensa: state.data_hora_dispensa,
          },
          token
        );

        Object.assign(state, {
          oleo_id: "",
          lote_id: "",
          quantidade: 1,
          data_hora_dispensa: "",
          div_nova_dispensa: false,
        });
        await Promise.all([fetchTipoOleo(), fetchTiposOleo()]);
        toast.success("Dispensa registrada com sucesso.");
      } catch (error) {
        toast.error(obterMensagemErro(error, "Não foi possível registrar a dispensa."));
      } finally {
        Object.assign(state, { is_saving: false });
      }
    }

    async function deleteDispensa(id) {
      if (confirm("Deseja remover esta dispensa?")) {
        state.deleting_id = id;
        try {
          await services.tipos_oleo.deleteDispensa({
            id,
            token,
          });
          await Promise.all([fetchTipoOleo(), fetchTiposOleo()]);
          toast.success("Dispensa removida com sucesso.");
        } catch (error) {
          toast.error(obterMensagemErro(error, "Não foi possível remover a dispensa."));
        } finally {
          state.deleting_id = null;
        }
      }
    }

    function dataBrasileiraValida(valor) {
      const partes = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor);
      if (!partes) return false;

      const dia = Number(partes[1]);
      const mes = Number(partes[2]);
      const ano = Number(partes[3]);
      const data = new Date(ano, mes - 1, dia);

      return (
        data.getFullYear() === ano &&
        data.getMonth() === mes - 1 &&
        data.getDate() === dia
      );
    }

    function obterMensagemErro(error, mensagemPadrao) {
      const resposta = error && error.response && error.response.data;
      if (resposta && resposta.errors) {
        const mensagens = Object.values(resposta.errors).flat();
        if (mensagens.length) return mensagens[0];
      }
      return (resposta && resposta.message) || mensagemPadrao;
    }

    function obterOleo(oleo) {
      if (oleo && oleo.oleo) return oleo.oleo;
      if (oleo && oleo.oleo_id && typeof oleo.oleo_id === "object") {
        return oleo.oleo_id;
      }
      return null;
    }

    function obterOleoId(oleo) {
      const tipoOleo = obterOleo(oleo);
      return tipoOleo ? tipoOleo.id : oleo.oleo_id;
    }

    function obterOleoNome(oleo) {
      const tipoOleo = obterOleo(oleo);
      return tipoOleo ? tipoOleo.nome : "Tipo de óleo indisponível";
    }

    return {
      state,
      abrirDis,
      saveDispensa,
      deleteDispensa,
      obterOleoId,
      obterOleoNome,
      rotuloLote,
      formatarLotes,
    };
  },
};
</script>

<style scoped>
.header_gradiant {
  background: linear-gradient(
    50deg,
    #007c7c 0%,
    #030c0c 100%,
    #007c7c
  ) !important;
}

h2 {
  color: black;
  font-size: 18pt;
  font-weight: 700;
}
.card .card-body {
  padding-top: 0 !important;
}

.card .card-header {
  padding-bottom: 0 !important;
}
.btn_cancelar {
  background-color: rgb(255, 255, 255);
  color: rgb(10, 36, 35);
  border: solid 3px rgb(10, 36, 35);
  padding: 15px;
  transition: 0.2s;
  margin-right: 15px;
  width: 20%;
  font-size: 11pt;
}

.div_btn_s_label {
  display: flex;
  flex-direction: column; /* Configura os itens em uma coluna */
}

.btn_sem_label {
  margin-top: auto; /* Move o elemento para o final do contêiner */
  text-align: center;
}

.btn_cancelar:hover {
  background-color: rgb(10, 36, 35);
  color: #ffffff;
}

.btn_salvar {
  background-color: rgb(255, 255, 255);
  border: solid 3px rgb(40, 149, 146) !important;
  color: rgb(40, 149, 146);
  padding: 5px;
  transition: 0.3s;
  width: 100%;
  font-size: 11pt;
}

.btn_salvar:hover {
  background-color: rgb(40, 149, 146);
  border: solid 3px rgb(40, 149, 146);
  color: rgb(0, 0, 0);
  transition: 0.3s;
  transform: none;
}

.btn_salvar_oleo {
  background-color: rgb(40, 149, 146);
  border: solid 3px rgb(40, 149, 146);
  color: #000;
  padding: 5px;
  transition: 0.3s;
  width: 200px;
  font-size: 11pt;
  font-weight: 700;
}

.btn_salvar_oleo:hover {
  background-color: rgb(34, 131, 128);
  transition: 0.3s;
  transform: none;
}

.div_btn {
  text-align: right;
}

input {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  font-size: 12pt;
  width: 100%;
  padding: 10px;
  outline: none;
}

input:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
  outline: none;
}

select {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  font-size: 12pt;
  width: 100%;
  padding: 10px;
}

select:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
  font-size: 12pt;
}

label {
  color: #000;
  margin-bottom: 0;
  font-size: 14pt;
}

.paciente-identificacao {
  color: #0a2423;
  font-size: 14pt;
  font-weight: 700;
  margin: 1rem 0 0;
}

.div_btns {
  width: 100%;
  text-align: right;
}

a {
  color: rgb(82, 181, 174);
}

a:hover {
  color: rgb(22, 82, 78);
}

.file_input {
  height: 180px;
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  padding-top: 22px;
  padding-bottom: 22px;
  font-size: 12pt;
}

.file_input:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
  font-size: 12pt;
}

textarea {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  padding-top: 22px;
  padding-bottom: 22px;
  font-size: 12pt;
  resize: none;
}

textarea:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
  font-size: 12pt;
}

.img_fetch {
  width: 100%;
}

td {
  color: #000;
  font-size: 11pt;
  font-weight: 600;
}

thead {
  background-color: #0a2423;
}
</style>
